<template>
  <div class="add-domain-modal">
    <span class="kw kw-x" @click="close" />
    <p class="title">{{ $t('delete-domain-confirm') }}</p>
    <p class="desc" v-html="$t('delete-domain-desc')" />
    <kw-button
      :button-text="$t('delete')"
      :buttonClasses="'kw-btn-danger'"
      button-type="text"
      @click="submit"
      :loading="loading"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ClickOutside from 'vue-click-outside';

export default {
  name: 'DeleteAiVisibilityDomain',
  directives: {
    ClickOutside,
  },
  props: {
    domainId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['getAiVisibilityDomainsList']),
  },
  methods: {
    ...mapActions(['deleteAiVisibilityDomain']),
    submit() {
      this.loading = true;
      this.deleteAiVisibilityDomain(this.domainId)
        .then((res) => {
          if (res) {
            this.close();
            if (this.$route.params?.id == this.domainId) {
              const redirectId = this.getAiVisibilityDomainsList?.length ? this.getAiVisibilityDomainsList[0].id : '';
              this.$router.push(`/ai-visibility/${redirectId}`);
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~sass/modal';
.add-domain-modal {
  position: relative;
  width: 100%;
  padding: 14px 16px 16px;
  p.title {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 16px;
    line-height: 100%;
  }
  p.desc {
    b {
      font-weight: 500;
    }
    font-family: Roboto;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0%;
  }
  .kw-x {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 7px;
    right: 7px;
    font-size: 10px;
    width: 16px;
    height: 16px;
    cursor: pointer;
    font-weight: 900;
    color: kw-color(kw-light-grey, 4);
  }
  & > button {
    margin-left: auto;
    width: 107px;
  }
}
</style>
